import { Component } from '@angular/core';
import { AuthService } from "app/services/auth/auth.service";
import { Router } from '@angular/router';
@Component({
    templateUrl: 'login.component.html'
})
export class LoginView {

    username: string;
    password: string;
    recaptcha: string;

    usernameValid = false;
    passwordValid = false;
    allValid = false;

    loading = false;

    errorMessage: string;

    constructor(private authService: AuthService, private router:Router) { }

    /**
     * 入力チェック処理
     */
    async validateForm(form) {
        if (form.invalid) {
            this.allValid = true;
            return;
        }

        await this.login();
    }

    /**
     * ログイン処理
     */
    async login() {
        try {
            
            this.loading = true;
            await this.authService.login(this.username, this.password, this.recaptcha);
            this.router.navigate(["/"]);

        } catch(err) {
            this.errorMessage = err.message;
        } finally {
            this.recaptcha = '';
            this.allValid = false;
            this.loading = false;
        }
    }
}



// WEBPACK FOOTER //
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/views/pages/login.component.ts